import { useState, useEffect } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import api from "../services/api";

const fmt = (v) => v?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [ano, setAno] = useState(new Date().getFullYear());
  useEffect(() => { api.get(`/dashboard?ano=${ano}`).then(({ data }) => setData(data)); }, [ano]);
  if (!data) return <div className="text-center py-5">Carregando...</div>;
  const evolucao = Object.entries(data.evolucao_mensal || {}).map(([mes, v]) => ({ mes, producao: v }));
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold mb-0">Dashboard</h4>
        <select className="form-select w-auto" value={ano} onChange={(e) => setAno(e.target.value)}>
          {[2024, 2025, 2026, 2027].map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      <div className="row g-3 mb-4">
        {[
          ["Comissão Auferida Total", fmt(data.total_producao), "bg-primary"],
          ["Comissão Total", fmt(data.total_comissao), "bg-success"],
          ["Prêmio Total", fmt(data.total_premio), "bg-warning text-dark"],
          ["Produtividade Total", fmt(data.total_produtividade), "bg-info"],
          ["Total Impostos", fmt(data.total_impostos), "bg-danger"],
          ["Vendedores Ativos", data.total_vendedores_ativos, "bg-dark"],
        ].map(([label, val, cls]) => (
          <div key={label} className="col-md-2">
            <div className={`card ${cls} text-center p-3`} style={{ color: cls.includes("warning") || cls.includes("info") ? "#000" : "#fff" }}>
              <div className="small">{label}</div>
              <div className="fs-5 fw-bold">{val}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="row g-4">
        <div className="col-md-8">
          <div className="card">
            <div className="card-header fw-bold">Evolução Mensal — Comissão Auferida</div>
            <div className="card-body">
              <ResponsiveContainer width="100%" height={280}>
                <BarChart data={evolucao}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="mes" />
                  <YAxis />
                  <Tooltip formatter={(v) => fmt(v)} />
                  <Bar dataKey="producao" fill="#0d6efd" name="Comissão Auferida" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card">
            <div className="card-header fw-bold">Top Vendedores</div>
            <div className="card-body p-0">
              <table className="table table-sm mb-0">
                <thead><tr><th>#</th><th>Vendedor</th><th>Comissão Auferida</th></tr></thead>
                <tbody>
                  {(data.ranking_vendedores || []).map((v, i) => (
                    <tr key={i}><td>{i + 1}</td><td>{v.nome}</td><td>{fmt(v.producao)}</td></tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
